import { ToastContainer, toast } from "react-toastify";
import ReactLoading from "react-loading";

import "./App.css";
import { StatusContext, StatusProvider } from "./contexts/Status.context";
import { UserInfoContext, UserInfoProvider } from "./contexts/UserInfo.context";
import MainLayout from "./layouts/main";
import "react-toastify/dist/ReactToastify.css";
import { useContext, useEffect, useState } from "react";
import { apiService } from "./services/api.service";
import LoadingScreen from "./components/UI/LoadingScreen";
import ReactPlayer from "react-player";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("e"); // this will return the value "paul"

  const location = useLocation();

  const { setIsLogged, setFullname, setEmail, setUserId, setIp } =
    useContext(UserInfoContext);
  const { setPageStatus, setEngine } = useContext(StatusContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (location.pathname == "/") getUserAuthentication(email as string);
    else {
      setIsLogged(true);
      setPageStatus("Free Test");
      setEngine("test");
    }
  }, [email]);

  useEffect(() => {
    const fetchIP = async () => {
      const ip = await apiService.getIpAddress();
      setIp(ip);
    };
    fetchIP();
  }, [setIp]);

  const getUserAuthentication = async (email: string) => {
    setIsLoading(true);
    try {
      const res = await apiService.getUser(email);
      const { data } = res;
      if (data.error || data.level < 1) {
        setPageStatus("Login");
        window.location.href =
          "https://microexpressionstrainingvideos.com/login";
      } else {
        const { display_name, user_email, user_login } = data.data;
        setFullname(display_name);
        setEmail(user_email);
        setUserId(user_login);
        setIsLogged(true);
        setPageStatus("Menu");
      }
    } catch (error) {
      setPageStatus("Login");
      window.location.href = "https://microexpressionstrainingvideos.com/login";
    }
    setIsLoading(false);
  };

  return (
    <>
      <div className="metv-app">
        <MainLayout />
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {isLoading && <LoadingScreen />}
    </>
  );
}

export default App;
